
import React from 'react'

const QuantityBadge = (props) => <div className={ `quantity-badge ${ (props.units > 0) ? 'visible' : '' }` }>
  <p className="p regular black s12">{ props.units }</p>
</div>

export default QuantityBadge
